import {useVerifiedPermissions} from '@flexinet/auth-components';

// Interim until FNP-1749. A failed permissions check leaves allowedActions
// empty, and the feature layouts redirect anyone missing an action to `/`,
// which sends a signed-in user back to the inbox: an endless loop. Throwing
// hands the failure to the router's errorElement (ApplicationErrorPage).
export const usePermissionsFailureGuard = () => {
    const {status} = useVerifiedPermissions();

    if (status === 'failed') {
        throw new Error("We couldn't check your permissions.");
    }
};
